/**
 * Sidebar Icon
 *
 */

import type { SVGProps } from 'react'

export default function ui_guides(props: SVGProps<SVGSVGElement> = {}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5 23.253H2.25C1.85218 23.253 1.47064 23.095 1.18934 22.8137C0.908035 22.5323 0.75 22.1508 0.75 21.753V2.25299C0.75 1.85517 0.908035 1.47364 1.18934 1.19233C1.47064 0.911026 1.85218 0.752991 2.25 0.752991H12.879C13.0761 0.753033 13.2712 0.791914 13.4533 0.867411C13.6353 0.942909 13.8007 1.05354 13.94 1.19299L19.811 7.06399C19.9503 7.20335 20.0607 7.36877 20.136 7.55082C20.2114 7.73287 20.2501 7.92797 20.25 8.12499V12.753"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7681 21.7612H13.5576V16.8091H14.707V16.1377H13.5576V15.606C13.5576 14.8916 13.8638 14.6821 14.4922 14.6821C14.6265 14.6821 14.707 14.6929 14.793 14.7036V14.0322C14.6963 14.0161 14.5674 14 14.4009 14C13.2944 14 12.7681 14.4888 12.7681 15.5522V16.1377H12V16.8091H12.7681V21.7612Z"
        fill="black"
      />
      <path
        d="M16.1411 21.7612H16.9307V16.1377H16.1411V21.7612ZM16.0015 14.7681C16.0015 15.0688 16.2432 15.3105 16.5332 15.3105C16.834 15.3105 17.0757 15.0688 17.0757 14.7681C17.0757 14.4727 16.834 14.231 16.5332 14.231C16.2432 14.231 16.0015 14.4727 16.0015 14.7681Z"
        fill="black"
      />
      <path
        d="M20.8301 23.1738C19.9976 23.1738 19.5088 22.7119 19.4121 22.2393H18.5903C18.7192 23.1523 19.4282 23.856 20.8301 23.856C22.1084 23.856 23.1611 23.1147 23.1611 21.7183V16.1377H22.4038V16.9595H22.3823C22.1299 16.4922 21.5229 16.0464 20.7173 16.0464C19.4121 16.0464 18.4614 16.9595 18.4614 18.603V19.124C18.4614 20.7783 19.4067 21.6968 20.7173 21.6968C21.5337 21.6968 22.1406 21.2349 22.3501 20.7676H22.3716V21.7236C22.3716 22.626 21.7646 23.1738 20.8301 23.1738ZM20.8354 16.7393C21.7754 16.7393 22.3716 17.502 22.3716 18.6782V19.0596C22.3716 20.2358 21.8076 20.9985 20.8354 20.9985C19.8472 20.9985 19.251 20.2681 19.251 19.0596V18.6782C19.251 17.4321 19.8525 16.7393 20.8354 16.7393Z"
        fill="black"
      />
      <path
        d="M20.25 8.25299H14.25C13.8522 8.25299 13.4706 8.09496 13.1893 7.81365C12.908 7.53235 12.75 7.15082 12.75 6.75299V0.752991"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
